import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from './components/RequireAuth';
import Credencial from './pages/Credencial';
import GrupoFamiliar from './pages/GrupoFamiliar';
import Inicio from './pages/Inicio';
import Login from './pages/Login';
import MisAportes from './pages/MisAportes';
import MisDatos from './pages/MisDatos';
import Novedades from './pages/Novedades';
import Tramites from './pages/tramites/Tramites';

/**
 * Portal de afiliados. El afiliado entra con CUIL + contraseña y ve solo lo propio
 * (vistas vw_mi_* / vw_mis_*; ADR #048 y #049).
 */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<Inicio />} />
        <Route path="/datos" element={<MisDatos />} />
        <Route path="/aportes" element={<MisAportes />} />
        <Route path="/familia" element={<GrupoFamiliar />} />
        <Route path="/credencial" element={<Credencial />} />
        <Route path="/tramites" element={<Tramites />} />
        <Route path="/tramites/nuevo" element={<Tramites />} />
        <Route path="/tramites/:id" element={<Tramites />} />
        <Route path="/novedades" element={<Novedades />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
